/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignTemplateRoleKind = {
    FacilityRepresentative: 'facility_representative',
    Resident: 'resident',
    ManualSigner: 'manual_signer',
} as const;
export type EsignTemplateRoleKind = typeof EsignTemplateRoleKind[keyof typeof EsignTemplateRoleKind];


export function instanceOfEsignTemplateRoleKind(value: any): boolean {
    for (const key in EsignTemplateRoleKind) {
        if (Object.prototype.hasOwnProperty.call(EsignTemplateRoleKind, key)) {
            if (EsignTemplateRoleKind[key as keyof typeof EsignTemplateRoleKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignTemplateRoleKindFromJSON(json: any): EsignTemplateRoleKind {
    return EsignTemplateRoleKindFromJSONTyped(json, false);
}

export function EsignTemplateRoleKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignTemplateRoleKind {
    return json as EsignTemplateRoleKind;
}

export function EsignTemplateRoleKindToJSON(value?: EsignTemplateRoleKind | null): any {
    return value as any;
}

export function EsignTemplateRoleKindToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignTemplateRoleKind {
    return value as EsignTemplateRoleKind;
}

